import Emitter from '@resources/js/helpers/Emitter'
import FlatpickrAdapter from '@resources/js/components/form/calendar/FlatpickrAdapter'

export default class FormView extends Emitter {
	#formElement
	#dateFromElement
	#dateToElement
	#submitBtnElement
	#calendarAdapter
	#calendarConfig
	#calendar
	#calendarElement

	constructor(domElementOrSelector, {calendarAdapter = FlatpickrAdapter, calendarConfig = {}} = {}) {
		super()
		this.#formElement =
			domElementOrSelector instanceof HTMLElement
				? domElementOrSelector
				: document.querySelector(domElementOrSelector)

		if (!this.#formElement) throw new Error('Form element is not found!')

		this.#dateFromElement = this.#formElement.querySelector('.js-form-from')
		this.#dateToElement = this.#formElement.querySelector('.js-form-to')

		this.#calendarElement = this.#formElement.querySelector(
			'.js-calendar-element'
		)

		this.#submitBtnElement = this.#formElement.querySelector('.js-form-btn')

		this.#calendarAdapter = calendarAdapter
		this.#calendarConfig = calendarConfig
		this.#calendar = null

		this.#init()
	}

	#init() {
		this.#initCalendar()
		this.#initEvents()
	}

	#initEvents() {
		this.#formElement.addEventListener('click', e => {
			if (e.target.closest('.js-calendar-trigger')) this.toggleCalendar()
		})

		this.#submitBtnElement.addEventListener(
			'click',
			this.#handleSubmit.bind(this)
		)
	}

	#initCalendar() {
		this.#calendar = new this.#calendarAdapter(
			this.#calendarElement,
			this.#calendarConfig
		)

		this.#calendar.on('change', selectedDates => {
			const [checkIn, checkOut] = selectedDates
			this.emit('dates-changed', { checkIn, checkOut })
		})
	}

	openCalendar() {
		this.#calendar.open()
	}

	closeCalendar() {
		this.#calendar.close()
	}

	toggleCalendar() {
		this.#calendar.toggle()
	}

	#handleSubmit() {
		this.emit('form-submit')
	}

	update(state) {
		if (state.checkIn) this.setCheckIn(state.checkIn)
		if (state.checkOut) this.setCheckOut(state.checkOut)
	}

	setCheckIn(elementDateString) {
		this.#dateFromElement.textContent = elementDateString
	}

	setCheckOut(elementDateString) {
		this.#dateToElement.textContent = elementDateString
	}
}
